import React from "react";
import ApInfoInlet from "./ApInfoInlet";
import ApActionButton from "./ApActionButton";

class ApHeader extends React.Component {
  constructor(props) {
    super(props);
  }

  renderBtn(id, desc, icon, active, click) {
    return (
      <ApActionButton
        description={active ? "Abbrechen" : desc}
        onClick={() => click(id)}
        active={active}
      >
        <i className={`fas fa-${icon}`} />
        {active ? (
          <i style={{ marginLeft: "8px" }} className="fas fa-times" />
        ) : null}
      </ApActionButton>
    );
  }

  render() {
    const isAnnotating = this.props.editMode === "annotation";
    const isDrawing = this.props.editMode === "draw";
    const isBoxSelecting = this.props.editMode === "boxselect";

    return (
      <div className="ApHeader">
        {this.renderBtn(
          "annotation",
          "Punktuelle Anmerkung",
          "map-marker-alt",
          isAnnotating,
          this.props.onEditModeButton
        )}
        {this.renderBtn(
          "boxselect",
          "Flächen Anmerkung",
          "vector-square",
          isBoxSelecting,
          this.props.onEditModeButton
        )}
        {this.renderBtn(
          "draw",
          "Zeichnen",
          "pencil-alt",
          isDrawing,
          this.props.onEditModeButton
        )}

        <ApInfoInlet
          onButtonClick={this.props.onButtonClick}
          label={this.props.label}
        />
        <i data-tip="Hilfe" className="ApQuestionBtn fas fa-question-circle" />
      </div>
    );
  }
}

export default ApHeader;



// WEBPACK FOOTER //
// ./src/components/approval/ApHeader.js